<template>
  <div>
    <div class="panel panel--minimal-pad">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-lg" data-toggle="modal"
               data-target="#createFilteredModal"><span>{{merchantName || 'Agents'}}</span> &nbsp; Transactions Overview <span class="pointer">{{message}}</span> </div>
        <div class="panel__header__right">
          <div class="filter__options">
            <button
              class="btn btn--default btn--flex"
              data-toggle="modal"
              data-target="#createFilteredModal"
            >
              <span class="btn__icon">
                <svg
                  class
                  enable-background="new 0 0 971.986 971.986"
                  version="1.1"
                  viewBox="0 0 971.986 971.986"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#576ae6"
                    d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z"
                  />
                </svg>
              </span>
              <span class="btn__text">Add filter</span>
            </button>
          </div>
          <div class="filter__options" style="padding-left: 15px;">
            <button class="btn btn--primary" @click="handlePosOverview(1)" id="DownloadFile">
              Download
            </button>
          </div> &nbsp; &nbsp;
          <div class="filter__options" v-click-outside="removeFilter">
            <select name="disburse-source" id="disburseSource" class="select__input select__input--sm" @change="optionType()" v-model="type">
              <option value="" disabled>Options</option>
              <option value="addMerchants">Link POS Agent</option>
              <option v-if="merchantInfo[0] && !merchantInfo[0].posId" value="assignTerminal">Assign Device Terminal</option>
            </select>
          </div>
        </div>
      </div>
      <!--equalized tables, for want of a better name, sigh-->
      <div class="panel__content panel__content--grey outer-container equalized-tables">
        <!--transfer history table-->

        <!--transfer loading-->
        <div class="loaderContainer" v-if="isLoading">
          <img src="/static/wave.gif" alt width="32" height="32" />
        </div>

        <div v-if="!noSummary && !isLoading">
          <div class="parent-container" v-for="(index, key) in TxnSummary">
            <div class="table__section table__section--head">
              <span v-if="index.type === 'wallet-disburse'">PAYOUT SUMMARY</span>
              <span v-else-if="index.type === 'wallet-fund'">FUNDING SUMMARY</span>
              <span v-else>E-BILLS SUMMARY</span>
            </div>
            <div class="card">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="20%">
                      <span>AMOUNT</span>
                      <br />
                      {{ index.amount | numeralize('0,0.00') }}
                    </td>
                    <td width="25%">
                      <span>AVERAGE</span>
                      <br />
                      {{ index.average | numeralize('0,0.00') }}
                    </td>
                    <td width="15%">
                      <span>REVENUE</span>
                      <br />
                      {{ index.commission | numeralize('0,0.00') }}
                    </td>
                    <td width="15%">
                      <span> VOLUME</span>
                      <br />
                      {{ index.count }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <br />
          </div>
        </div>
        <div class="parent-container" v-if="!merchantInfoEmpty" v-for="merchant in merchantInfo">
            <div class="table transfer__table" v-bind:id="merchant.id">
              <div class="table__section table__section--head">
                <span>MERCHANT INFORMATION</span>
              </div>
              <div class="table__section table__section--body">
                <div class="table__row">
                  <div class="table__data table__data--bold table__data--20">
                    <div class="table__data--default">
                      <span>{{merchant.name}}</span> <br />
                      <small> Merchant Id: {{ merchant.id }} </small>
                      <br />
                    </div>
                  </div>
                  <div class="table__data table__data--20">
                    <div class="table__data--default">Location: {{merchant.country}}</div>
                    <small><div class="table__data--result">{{merchant.state || '-'}} | {{merchant.city || '-'}} </div></small>
                  </div>

                  <div class="table__data table__data--15">
                    <div class="table__data--default">Address </div>
                    <small class="table__data--result">{{merchant.address || '-'}}</small>
                  </div>

                  <!-- table data -->
                  <div class="table__data table__data--15">
                    <div class="table__data--default">POSID </div>
                    <small class="table__data--result">{{merchant.posId || '-'}}</small>
                  </div>

                  <!-- table data -->
                  <div class="table__data table__data--20">
                    <div class="table__data--default">
                      Phone </div>
                      <small class="table__data--result">{{merchant.phonenumber || 'No phone number'}}</small>
                  </div>
                </div>
              </div>

              <div class="table table--special-width">
                <div class="table__section table__section--body">
                  <!-- table row -->
                  <div class="table__row spacer"></div>
                </div>
              </div>
            </div>
          </div>
         <!--if empty transfer list-->
        <div class="panel__empty" v-if="noSummary && merchantInfoEmpty">
          <div class="panel__empty__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70" viewBox="0 0 92 70"><g fill="none" fill-rule="evenodd" transform="translate(-1 -1)"><rect width="43" height="60" x="10" y="6" fill="#D6DBEB" opacity=".269" rx="3" transform="rotate(-22 31.5 36)"></rect> <rect width="43" height="60" x="41" y="6" fill="#D6DBEB" opacity=".269" rx="3" transform="rotate(22 62.5 36)"></rect> <g fill-rule="nonzero"><g transform="translate(47 45)"><path fill="#4B536B" d="M10.968.279a5.039 5.039 0 1 0 .001 10.077A5.039 5.039 0 0 0 10.968.28zm2.178 7.326c-.134.27-.32.495-.562.676a2.561 2.561 0 0 1-.859.408c-.13.037-.266.064-.404.086v.591h-.775v-.542a4.194 4.194 0 0 1-.562-.05 3.82 3.82 0 0 1-.569-.134 2.764 2.764 0 0 1-.418-.164 1.021 1.021 0 0 1-.244-.156.474.474 0 0 1-.118-.23 1.924 1.924 0 0 1-.042-.465c0-.135.004-.243.014-.324a.776.776 0 0 1 .042-.195c.019-.049.042-.082.069-.098a.21.21 0 0 1 .105-.024c.052 0 .127.029.227.087.101.058.225.122.374.191.149.071.322.135.52.195s.422.091.673.091c.159 0 .299-.015.422-.048s.23-.079.321-.14a.593.593 0 0 0 .207-.23.702.702 0 0 0 .069-.321.535.535 0 0 0-.128-.359 1.128 1.128 0 0 0-.343-.262 3.983 3.983 0 0 0-.481-.209 11.381 11.381 0 0 1-.552-.217 5.015 5.015 0 0 1-.55-.272 2.077 2.077 0 0 1-.482-.377 1.694 1.694 0 0 1-.341-.538 1.956 1.956 0 0 1-.13-.753c0-.297.058-.571.175-.82.116-.248.283-.461.503-.639.218-.176.485-.314.799-.412.14-.043.288-.077.443-.101v-.582h.775v.54a4.14 4.14 0 0 1 .907.143c.149.042.275.088.377.136.102.049.176.091.22.126a.315.315 0 0 1 .093.105.454.454 0 0 1 .043.126 2.556 2.556 0 0 1 .034.449c0 .126-.003.228-.01.307a.779.779 0 0 1-.035.189c-.016.045-.038.077-.065.093a.193.193 0 0 1-.098.025.484.484 0 0 1-.195-.073 3.307 3.307 0 0 0-.331-.157 4.035 4.035 0 0 0-.461-.157 2.205 2.205 0 0 0-.596-.073c-.159 0-.296.016-.412.049a.773.773 0 0 0-.286.14.61.61 0 0 0-.225.474c0 .145.044.266.134.363.088.098.204.184.349.258.144.076.307.145.491.21.184.064.37.136.558.213.189.077.375.166.559.268.183.102.348.228.491.377.145.149.261.327.349.534.088.207.132.452.132.736a2.148 2.148 0 0 1-.201.936z"></path> <circle cx="2.34" cy="5.317" r="1.679" fill="#D6DBEB"></circle> <circle cx="19.596" cy="5.317" r="1.679" fill="#D6DBEB"></circle></g> <path fill="#4B536B" d="M72.194 41.635H43.742c-.785 0-1.421.563-1.421 1.257v14.852c0 .694.636 1.257 1.421 1.257h28.451c.785 0 1.421-.563 1.421-1.257V42.892c.001-.695-.635-1.257-1.42-1.257zM44.59 54.338v-7.357c.987-.009 3.28-.352 3.286-3.34h20.221c.017.994.381 3.197 3.25 3.247v7.377c-.963.036-2.84.409-3.122 2.729h-20.32c-.164-1.108-.837-2.65-3.315-2.656z"></path> <g fill="#4B536B"><path d="M35.6 25.5h4.466v4.466H35.6zM43.615 25.5h4.466v4.466h-4.466zM51.631 25.5h4.466v4.466h-4.466zM27.584 32.291h4.466v4.466h-4.466zM27.584 25.5h4.466v4.466h-4.466zM35.6 32.291h4.466v4.466H35.6zM43.615 32.291h4.466v4.466h-4.466zM51.631 32.291h4.466v4.466h-4.466zM27.584 39.081h4.466v4.466h-4.466zM39.724 42.892c0-.553.123-1.079.342-1.554v-2.256H35.6v4.466h4.124v-.656z"></path> <g><path d="M31.147 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM41.873 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM52.599 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.67 1.488-1.488 1.488z"></path> <path d="M57.022 12.124h-1.079v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636H26.66c-4.563 0-8.274 3.712-8.274 8.274v20.375c0 4.563 3.712 8.274 8.274 8.274h13.064v-3.711H26.66a4.568 4.568 0 0 1-4.563-4.563V23.435h39.489v15.602h3.711V20.399c-.001-4.563-3.712-8.275-8.275-8.275z"></path></g></g></g></g></svg>
          </div>
          <div class="panel__empty__text">No transactions with current filter.
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="confirmAssign"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmAssign"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">Assign
              <span>Confirmation</span>
            </div>
            <!-- Modal close button -->
            <button
              type="button"
              class="close btn btn--default btn--sm"
              data-dismiss="modal"
              aria-label="Close"
              @click="utilityMethods().triggerRefresh()"
              ref="closeModal"
            >
              <span>Close</span>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <form
              class="disburse__confirmation"
              @submit.prevent="handleDeviceAssign()"
              v-if="!assignDeviceFinished"
            >
              <div class="disburse__confirmation__title text-center"> You are about to assign a device to the account below </div>
              <div class="disburse__confirmation__breakdown">
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Merchant</div>
                  <div class="breakdown__item__result">{{merchantInfo[0] && merchantInfo[0].name}}</div>
                </div>
              </div>

              <br>

              <!-- <div class="disburse__confirmation__breakdown">
                <div class="breakdown__item" v-for="merchants in userToLink.merchants">
                  <div class="breakdown__item__name">Merchant Name</div>
                  <div class="breakdown__item__result">{{merchants.name}}</div>
                </div>
              </div> -->


              <!--confirm disbursement-->
              <div class="disburse__confirmation__submit">
                <button
                  class="btn btn--primary btn--block submit__paymentForm"
                  id="assignButton"
                  type="submit"
                >CONFIRM ASSIGN</button>
              </div>
            </form>

            <div class="disburse__result text-center" v-if="assignDeviceFinished">
              <div v-if="assignDeviceSuccessful">
                <div class="result-img">
                  <svg
                    class="icon icon--custom-big"
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline
                      points="38 15 22 33 12 25"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text">Device successfully assigned</p>
                <button
                  class="btn btn--default"
                  @click="utilityMethods().triggerRefresh()"
                >Close</button>
              </div>

              <div v-if="assignDeviceFailed">
                <div class="result-img">
                  <svg
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon--custom-big"
                  >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline
                      points="16 34 25 25 34 16"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                    <polyline
                      points="16 16 25 25 34 34"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p
                  v-for="error in assignDeviceErrors"
                  class="disburse__result__error error-text"
                >{{error}}</p>
                <button
                  class="btn btn--primary"
                  @click="utilityMethods().triggerRefresh2()"
                >Retry linking</button>
                <button
                  class="btn btn--default"
                  @click="utilityMethods().triggerRefresh()"
                >Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="createFilteredModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createFilteredModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xsf" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <!-- Modal Body -->
          <div class="modal__body">
            <div class>
              <form action class="form form__padf" @submit.prevent="handlePosOverview()">
                <div class="form__item">
                  <datepicker
                    :inputClass="'form__input input'"
                    required="required"
                    :placeholder="'Date Start'"
                    @selected="formatStartDate"
                    :value="search.createdAt.from"
                  ></datepicker>
                </div>
                <div class="form__item">
                  <datepicker
                    :inputClass="'form__input input'"
                    required="required"
                    :placeholder="'Date End'"
                    @selected="formatEndDate"
                    :value="search.createdAt.to"
                  ></datepicker>
                </div>
                <div class="form__item">
                  <select name="status1" class="select__input select__input--md" v-model="search.currency">
                    <option value="">Select a Currency</option>
                    <option
                      v-for="option in walletList"
                      v-bind:value="option.currencyCode"
                    >{{ option.currencyCode }}</option>
                    <!-- <option value="NGN">NGN</option>
                    <option value="KES">KES</option>
                    <option value="GHS">GHS</option>
                    <option value="USD">USD</option> -->
                  </select>
                  <div class="select__icon select__icon--in-pagination">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                  </div>
                </div>

                <br />
                <br />

                <div class="form__item">
                  <button
                    id="fundWallet"
                    type="submit"
                    class="btn btn--primary btn--block beneficiary_submit"
                    @click="filter()"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createFilteredModal"
                  >Create Filter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTransfers
} from "../../utils/wallet-transactions/transferService";
import {
  getSingleUser, assignDevice
} from "../../utils/user/getUserDetails";
import ModalTemplate from "@/components/partials/ModalTemplate.vue";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  created() {
    this.handlePosOverview();
  },

  mounted() {},

  beforeRouteUpdate(to, from, next) {
    this.$Progress.start();
    this.handlePosOverview();
    this.$Progress.finish();
    // don't forget to call next()
    next();
  },

  data() {
    return {
      isLoading: true,
      noSummary: false,
      search: {
        createdAt: {
          from: "",
          to: ""
        },
        currency: "",
        loadReport: true,
        merchantId: window.localStorage.getItem('merchantId'),
      },
      merchantName: false,
      type: '',
      download: 0,
      currency: "",
      TxnSummary: [],
      merchantInfo: [],
      merchantInfoEmpty: true,
      message: '',
      assignDeviceFinished: false,
      assignDeviceSuccessful: false,
      assignDeviceFailed: false,
      assignDeviceErrors: [],
    };
  },
  props: {
    name
  },
  components: {
    "modal-template": ModalTemplate,
    "v-select": vSelect,
    Datepicker
  },
  watch: {
    // call again the fetch method if the route changes
      '$route': 'handlePosOverview'
  },

  computed: {
    walletList() {
      let a = [];
      if(Object.keys(window.localStorage.getItem("walletList")).length > 0) {
        Object.keys(
          JSON.parse(window.localStorage.getItem("walletList"))
        ).forEach(response => {
          if (
            JSON.parse(window.localStorage.getItem("walletList"))[response]
              .currencyBalance > 1
          ) {
            a.push(
              JSON.parse(window.localStorage.getItem("walletList"))[response]
            );
          }
        });
      }
      return a;
    }
  },

  methods: {
    formatDateRange(start, end) {
      const startD = moment(start).format("D");
      const endD = moment(end).format("D");
      const startMn = moment(start).format("MM");
      const endMn = moment(end).format("MM");
      const startYr = moment(start).format("YY");
      const endYr = moment(end).format("YY");
      let d = "";

      if (startD === endD && startMn === endMn && startYr === endYr) {
        d = `${startD} ${moment(end).format("MMMM")} ${endYr}`;
      } else if (startMn === endMn && startYr === endYr) {
        d = `${startD} -
    ${moment(end).format("D")} ${moment(end).format(
          "MMMM"
        )} ${endYr}`;
      } else if (startYr === endYr) {
        d = `${startD} ${moment(start).format("MMM")} -
    ${moment(end).format("D")} ${moment(end).format(
          "MMM"
        )} ${endYr}`;
      } else {
        d = `${startD} ${moment(start).format("MMM")} ${startYr} -
    ${moment(end).format("D")} ${moment(end).format(
          "MMM"
        )} ${endYr}`;
      }

      return d;
    },

    optionType() {
      if (this.type === 'addMerchants') {
        $("#createAccountModal").modal("show");
      } else if (this.type === 'assignTerminal') {
        $("#confirmAssign").modal("show");
      }
    },

    toLowerCase(value) {
      return value.toLowerCase();
    },

    formatStartDate (date) {
      this.search.createdAt.from = moment(date).format().toString().split('T')[0];
    },

    formatEndDate (date) {
      this.search.createdAt.to = moment(date).format().toString().split('T')[0];
    },

    filter() {
      let data = {};
      if (this.search.createdAt.from == null) {
        this.search.createdAt.from = "";
      }
      if (this.search.createdAt.to == null) {
        this.search.createdAt.to = "";
      }
      if (this.search.currency === "") this.search.currency = "NGN";
      data = this.search;
      this.$store.commit("updateTxnSummary", data);
      // location.reload();
    },

    handlePosOverview(download = 0) {
      let data2 = {};
      this.download = download;
      if (window.localStorage.getItem("TxnSummary") == null) {
        this.search.createdAt.from = moment()
          .startOf("month")
          .format().toString().split('T')[0];
        this.search.createdAt.to = moment().format().toString().split('T')[0];
        this.search.currency = "NGN";
        data2 = this.search;
        data2.loadReport = true;
        this.$store.commit("updateTxnSummary", data2);
      }
      data2.loadReport = true;
      data2 = JSON.parse(window.localStorage.getItem("TxnSummary"));
      this.search = JSON.parse(window.localStorage.getItem('TxnSummary'));
      this.$Progress.start();
      if (this.$route.params.id) data2.merchantId = this.$route.params.id;
      else data2.merchantId = window.localStorage.getItem('merchantId');
      this.currency = data2.currency;
      this.message = '';
      this.$Progress.start();
      getTransfers(1, 1, data2, this.download)
      .then(resp => {
        let next = {};
        console.log(resp.data.data);
        if (resp.status === 200) {
          this.$Progress.finish();
          if(this.search.currency !== ''){
            this.message += ' • ' + this.search.currency.toUpperCase() +' ';
          }
          let date = this.formatDateRange(this.search['createdAt']['from'], this.search['createdAt']['to']);
          this.message += ' • ' +date;
          this.isLoading = false;

          if (resp.data.data) {
            if((Object.keys(resp.data.data.response).length === 0) && (typeof resp.data.data === 'object')){
              this.noSummary = true;
            } else {
              this.TxnSummary = resp.data.data.response;
              this.noSummary = false;
              this.merchantName = this.TxnSummary[0].merchant;
            }
          } else if (resp.data.file) {
              this.downloadFile(`https://frontend.moneywaveapp.com/admin/v1/file/${resp.data.file.split('file/')[1]}`);
          }
        }
        if (this.$route.params.id) next = getSingleUser(data2.merchantId);
        return next;
      })
      .then((user) => {
        this.merchantInfo = [];
        if (user.status === 200) {
          if (typeof user.data === "object" && user.data.length > 0) {
            console.log(user.data[0]);
            this.merchantInfo.push(user.data[0]);
            this.merchantInfoEmpty = false;
          } else this.merchantInfoEmpty = true;
        }
      })
      .catch((err) => {
        console.log(err);
      })
    },

    removeFilter() {
      this.type = '';
    },

    handleDeviceAssign() {
      this.$Progress.start();
      const targetMerchant = this.merchantInfo[0].id;
      const parentId = window.localStorage.getItem('merchantId');

      document.getElementById('assignButton').disabled = true;

      assignDevice(targetMerchant, parentId)
      .then((resp) => {
        if (resp.data.data.data.responsecode === '00') {
          this.$Progress.finish();
          this.assignDeviceFinished = true;
          this.assignDeviceSuccessful = true;
          this.assignDeviceFailed = false;
        } else {
          this.$Progress.fail();
          this.assignDeviceFinished = true;
          this.assignDeviceSuccessful = false;
          this.assignDeviceFailed = true;
          this.assignDeviceErrors.push('Device could not be assigned')
        }
        document.getElementById('assignButton').disabled = false;
      })
      .catch((err) => {
        this.$Progress.fail();
        this.assignDeviceFinished = true;
        this.assignDeviceSuccessful = false;
        this.assignDeviceFailed = true;
        this.assignDeviceErrors.push(err.response.data.message || err.response.data.error.message || 'Something went wrong')
        document.getElementById('assignButton').disabled = false;
      })
    },

    downloadFile(text){
      window.open(text, "_blank");
    },

    utilityMethods() {
      let self = this;
      return {
        //page load methods
        triggerRefresh() {
          self.removeFilter();
          $("#confirmAssign").modal("hide");
          setTimeout(() => { self.utilityMethods().triggerRefresh2(); }, 1000);
        },

        triggerRefresh2 () {
          self.assignDeviceFinished = false;
          self.assignDeviceSuccessful = false;
          self.assignDeviceFailed = false;
          self.assignDeviceErrors = [];
        }
      };
    }
  }
};
</script>

<style scoped>
#snackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: deepskyblue;
  color: white;
  padding: 5px;
  text-align: center;
}

.pointer {
  cursor: pointer;
}

#negsnackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: red;
  color: white;
  padding: 5px;
  text-align: center;
}

#snackbar.show {
  visibility: visible;
}

#negsnackbar.show {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/pos/posOverview.vue